import { type HydraCollection } from '~/models/ecommerce-providers/sylius/interface'

function usePagerViewCreated(hydra: HydraCollection<any>, count: string) {
	const url = new URL(hydra['hydra:view']?.['hydra:last'] || '', 'http://a')

	if (
		hydra['hydra:totalItems'] &&
		!(
			hydra['hydra:totalItems'] %
			Number.parseInt(url.searchParams.get('itemsPerPage') || count)
		)
	) {
		url.searchParams.set(
			'page',
			String(Number.parseInt(url.searchParams.get('page') || '1') + 1),
		)
	}

	return url.search
}

export { usePagerViewCreated }
